import { DataPage } from '@/app.routes';
import { AppConfigService } from '@/services/app-config.service';
import { MenuToNative, MenuToNativeId } from '@/services/bridge/bridge.service';
import { NavService } from '@/services/nav.service';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';

export interface BreadcrumbItem {
  text: string;
  link: string;
}

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: true,
    imports: [NgFor, RouterLink]
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  @Output() current = new EventEmitter<BreadcrumbItem[]>();
  @Input() isSharedProperty = false;
  sub = new Subscription();

  private dataPage: DataPage;
  breadcrumb: BreadcrumbItem[];

  constructor(private navService: NavService, private appConfigService: AppConfigService) {}

  ngOnInit(): void {
    this.sub = combineLatest([this.navService.menuItems$, this.navService.currentDataPage$]).subscribe(
      ([menu, dataPage]) => {
        this.handler(menu, dataPage);
      }
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  handler(menu: MenuToNative[], dataPage: DataPage) {
    this.dataPage = dataPage;
    const filtered = this.search(menu, dataPage.page)?.filter((l) => l.id !== MenuToNativeId.PROP_MAIN) || [];
    this.mapper(filtered);
    this.current.next(this.breadcrumb);
  }

  search(items: MenuToNative[], page: MenuToNativeId): MenuToNative[] | null {
    const list: MenuToNative[] = [];
    for (let index = 0; index < items.length; index++) {
      const element = items[index];
      if (element.id === page) {
        list.push(element);
        return list;
      } else if (element.childs) {
        const found: MenuToNative[] | null = this.search(element.childs, page);
        if (found) {
          list.push(element);
          return [...list, ...found];
        }
      }
    }
    return null;
  }

  mapper(menu: MenuToNative[]) {
    const list: BreadcrumbItem[] = menu?.map((m) => {
      return {
        text: m.title,
        link: m.link
      };
    });
    // if uid
    if (this.dataPage.uid) {
      const prop = this.appConfigService.selectedProp;
      const propertyItem: BreadcrumbItem = {
        text: prop.name,
        link: this.navService.getNavEnvById(MenuToNativeId.PROP_MAIN).link
      };
      list.splice(1, 0, propertyItem);
    }

    this.breadcrumb = list;
    this.overrideMyProperty();
  }

  // CAUTION: si d'autres éléments de menu sont modifiables
  // on pourrait gérer cela dans la NavService
  // ainsi le this.navService.menuItems$ serait déjà construit mais demande plus
  // de développement
  overrideMyProperty() {
    const found = this.navService.getNavEnvById(MenuToNativeId.HOME_PROPERTY);
    if (found) {
      let MyPropertyText = found.title;
      if (this.isSharedProperty) {
        MyPropertyText = 'Propriétés partagées';
      }

      if (this.breadcrumb?.[0]) {
        this.breadcrumb[0].text = MyPropertyText;
        this.breadcrumb = [...this.breadcrumb];
      }
    }
  }
}
